<template>
    <div>
        <section class="content-header mt-2">
            <h3 v-if="this.$route.params.organization_id">Edit Organization</h3>
            <h3 v-else>Add Organization</h3>
        </section>
        <section class="content">
            <div class="row">
                <div class="col-md-6">
                    <success-component
                            v-if="success.length > 0"
                            :message="success">
                    </success-component>
                    <error-component
                            v-if="exceptions.length > 0"
                            v-bind="exceptions[0]">
                    </error-component>
                    <b-form @submit.prevent="onSubmit">
                        <b-form-group
                                label="Organization Name:"
                                label-for="name">
                            <b-form-input name="name"
                                          type="text"
                                          autofocus
                                          v-model="organization.name"
                                          v-validate="{required:true}"
                                          :state="errors.has('name') ? false: null"
                                          placeholder="Enter organization name">
                            </b-form-input>
                            <em v-if="errors.has('name')" class="text-danger">
                                {{ errors.first('name') }}
                            </em>
                        </b-form-group>

                        <div class="plans">
                            <b-form-group  >
                                <h4>Organization Plan</h4>
                                <div class="info">
                                    👩‍🏫 We have different plans for your organizations depending on your needs, you can use the free tier for all the time that you want.
                                    If you need more resources you can select for one of the paid options. If you want to be charge for your monthly usage you can pay as you go.
                                    <br />
                                    <br />
                                    Select the plans to see the details and the impact with your current usage.
                                    <br />
                                    <br />
                                </div>
                                <div class="row">
                                    <div class="col-md-4 options" >
                                        <h5>Select your plan</h5>
                                        <b-form-radio-group v-model="organization.plan_id">
                                            <b-form-radio v-for="plan in plans" :value="plan.id" :key="plan.id">{{ plan.name }}</b-form-radio>
                                        </b-form-radio-group>
                                    </div>
                                    <div class="col-md-4 details">
                                        <h5>Plan details</h5>
                                        <div class="mt-2 line">
                                            <label>Users: </label> <span v-if="plan.name === 'As you go'">Unlimited</span> <span v-else>{{ plan.limit_users }}</span>
                                        </div>
                                        <div class="mt-2 line">
                                            <label>Objects: </label> <span v-if="plan.name === 'As you go'">Unlimited</span> <span v-else>{{ plan.limit_objects }}</span>
                                        </div>
                                        <div class="mt-2 line">
                                            <label>Price: </label>
                                            <ul class="mb-0 pl-4"  v-if="plan.name === 'As you go'" >
                                                <li>Per object: ${{ plan.price.value.per_object }}</li>
                                                <li>Per user: ${{ plan.price.value.per_user }}</li>
                                            </ul>
                                            <span class="mt-2 line" v-else >
                                                ${{ plan.price.value }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="usage col-md-4">
                                        <h5>Current Usage</h5>

                                        <div v-if="plan.name !== 'As you go'">
                                            <span>{{ organization.total_users }} of {{ plan.limit_users }} users</span>
                                            <b-progress
                                                    :value="organization.total_users"
                                                    :max="plan.limit_users"
                                                    :variant="organization.total_users >= plan.limit_users ? 'danger' : 'primary'"
                                                    class="w-50 mb-2" />
                                            <span>{{ organization.total_objects }} of {{ plan.limit_objects }} objects</span>
                                            <b-progress
                                                    :value="organization.total_objects"
                                                    :max="plan.limit_objects"
                                                    :variant="organization.total_objects >= plan.limit_objects ? 'danger' : 'primary'"
                                                    class="w-50 mb-4" />
                                        </div>

                                        <div v-if="plan.name === 'As you go'">
                                            <div><label>User: </label> {{ organization.total_users }} x u$d {{ plan.price.value.per_user }} = u$d  {{ organization.total_users * plan.price.value.per_user }} </div>
                                            <div><label>Objects: </label> {{ organization.total_objects }} x u$d  {{ plan.price.value.per_object }} = u$d  {{ organization.total_objects * plan.price.value.per_object }} </div>
                                            <div><label>Estimated Monthly Cost: </label> u$d {{ (organization.total_users * plan.price.value.per_user) +  (organization.total_objects * plan.price.value.per_object) }}</div>
                                            <div>
                                                &nbsp;
                                            </div>
                                            <div class="info-small">
                                                ℹ️ The Cost is estimated, the monthly invoice might change at the end of the month depending on your usage.
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </b-form-group>
                        </div>




                        <b-link class="btn btn-secondary mr-2" :to="{ name : 'organization' }">
                            <font-awesome-icon icon="arrow-left"/> Back
                        </b-link>
                        <b-btn variant="success"
                               @click="onSubmit"
                               :disabled="loading.save">
                            <font-awesome-icon icon="save" class="mr-1" />
                            <span>Save</span>
                            <b-spinner
                                v-if="loading.save"
                                small
                                class="ml-2" />
                        </b-btn>
                    </b-form>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import ErrorComponent from '../../components/ErrorView.vue';
    import SuccessComponent from '../../components/Success.vue';
    import {mapState} from 'vuex';
    import {PlanService} from "../../api.service";

    export default {
        $_veeValidate: {
            validator: 'new'
        },
        props: ['organization_id'],
        data() {
            return {
                loading: {
                    save: false,
                },
                organization: {
                    id: 0,
                    name: '',
                    plan_id: 1,
                    total_objects: 0,
                    total_users: 0,
                },
            }
        },
        computed: {
            ...mapState({
                plans: state => state.plans,
                success: state => state.success,
                exceptions: state => state.exceptions,
            }),
            plan() {
                let planData = {
                    name: '',
                    price: 0,
                    limit_objects: 0,
                    limit_users: 0,
                };

                let planSelected = this.$store.getters.getPlanById(parseInt(this.organization.plan_id));
                if(planSelected) {
                    planData.name = planSelected.name;
                    planData.price = JSON.parse(planSelected.price);
                    planData.limit_objects = parseInt(planSelected.limit_objects);
                    planData.limit_users = parseInt(planSelected.limit_users);
                }

                return planData;
            },
        },
        created() {
            this.$store.dispatch('fetchPlans');

            if (this.organization_id) {
                this.$store.dispatch('fetchOrganizations')
                    .then(() => {
                        this.organization = this.$store.getters.getOrganizationById(parseInt(this.organization_id));
                    });
            }
        },
        beforeDestroy() {
            this.$store.dispatch('clearMessages');
        },
        methods: {
            onSubmit() {
                this.$validator.validateAll().then((valid) => {
                    if (valid) {
                        this.loading.save = true;
                        if (this.organization_id) {
                            this.$store.dispatch('editOrganization', {
                                id: this.organization_id,
                                name: this.organization.name,
                                plan_id: this.organization.plan_id})
                            .finally(() => {
                                this.loading.save = false;
                            });
                        } else {
                            this.$store.dispatch('addOrganization', {name: this.organization.name, plan_id: this.organization.plan_id})
                                .then(res => {
                                    this.$store.dispatch('fetchOrganizations').then(() => {
                                        if (this.$store.getters.getOrganizations.length === 1) {
                                            let payload = {
                                                id: res.data.data.organization.owner_id,
                                                default_organization_id: res.data.data.organization.id,
                                            };
                                            this.$store.dispatch('setOrganizationSelected', payload);
                                        }
                                    });
                                })
                                .finally(() => {
                                    this.loading.save = false;
                                });
                        }
                    }
                })
            }
        },
        components: {
            ErrorComponent,
            SuccessComponent
        }
    }
</script>

<style>
    .plans {
        border: 1px solid #ccc;
        padding: 20px;
        margin-bottom: 20px;
        border-radius: 5px;
    }

    .plans .custom-control.custom-control-inline.custom-radio {
        display: block;
        margin-bottom: 20px;
        font-weight: bold;
        font-size: 17px;
    }

    .plans label {
        font-weight: bold;
    }

    .plans .details .line {
        margin-bottom: 5px;
        font-size: 17px;
    }

    .info {
        margin-bottom: 20px;
        font-size: 15px;
    }

    h4 {
        border-bottom: 1px solid #eee;
        margin-bottom: 20px;
        padding-bottom: 10px;
    }

    h5 {
        margin-bottom: 20px;
    }
</style>